<template>
  <div class="uptphone">
    <p>已绑定手机号</p>
    <b style="margin-bottom: 0.55rem" v-if="mobile">
      <div class="security-code security-code1" v-if="time != 0">
        +{{ areaCode }}
        <img src="../../assets/images/jt6.png" />
      </div>
      <div class="security-code" v-if="time == 0" @click="chooseCountryClick">
        +{{ areaCode }}
        <img src="../../assets/images/jt6.png" />
      </div>
      {{ mobile.slice(0, 3) }}&nbsp;{{ mobile.slice(3, 7) }}&nbsp;{{ mobile.slice(7, 11) }}
    </b>

    <div class="codeWrap">
      <div class="inputWrap">
        <input placeholder="图形验证码" v-model="codeValue" @keyup="codeChange" />
        <img class="close" src="../../assets/images/close.png" v-if="CodeFlag" @click="clearCode" />
      </div>
      <div class="codeImg" ref="codeImg" @click="code">
        <img :src="codeImg" />
      </div>
    </div>

    <security-code v-model="authCode" :code="authCode" :type="typeFa" :number="num"></security-code>
    <button class="secuCode" :class="passFlag ? 'gainRed' : ''" v-if="time == 0" @click="sendAgain">
      获取验证码
    </button>
    <button class="secuCode" v-if="time != 0">{{ time }}s后重新发送</button>
  </div>
</template>

<script>
import securityCode from '../common/securityCode'
import { basepath, random_string } from '../../assets/common/js/config'
export default {
  name: 'updatePhone',
  components: {
    securityCode
  },
  data() {
    return {
      authCode: '',
      time: 0,
      typeFa: 'security',
      num: 6,
      mobile: null,
      areaCode: '86',
      sendstatus: false,
      codeValue: '',
      CodeFlag: false,
      codeImg: '',
      passFlag: false,
      timeout: null
    }
  },
  mounted: function () {
    if (sessionStorage.getItem('ckys4_mobile')) {
      this.mobile = sessionStorage.getItem('ckys4_mobile')
    }
    if (this.$route.query.area_code) {
      this.areaCode = this.$route.query.area_code
    }
    this.code()
  },
  destroyed() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    next()
  },
  watch: {
    authCode(n) {
      if (n.length == this.num) {
        this.codeClick()
      }
    },
    codeValue() {
      this.codeChange()
    }
  },
  methods: {
    code: function () {
      var width = this.$refs.codeImg.clientWidth
      var height = this.$refs.codeImg.clientHeight
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg =
        basepath +
        'Msg/Captcha/getValidateCode?sessionid=' +
        this.timeout +
        '&width=' +
        width +
        '&height=' +
        height
    },
    codeChange: function () {
      this.CodeFlag = this.codeValue ? true : false
      this.checkInfo()
    },
    clearCode: function () {
      this.codeValue = ''
      this.CodeFlag = false
      this.checkInfo()
    },
    checkInfo: function () {
      this.passFlag = this.codeValue.length >= 4 ? true : false
    },
    checkPhone: function () {
      if (!/[0-9A-Za-z]{4,6}$/.test(this.authCode)) {
        return false
      } else {
        return true
      }
    },
    // 手机验证码校验接口
    codeClick() {
      if (!this.sendstatus) {
        this.$toast('请先获取验证码')
        this.authCode = ''
        return
      }
      var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.authCode
      var that = this
      if (that.checkPhone()) {
        that.$customRequestAjax(url).then((res) => {
          if (res.data.code === 200) {
            that.$router.replace('/inphone')
          } else {
            that.authCode = ''
          }
        })
      }
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (!this.passFlag) {
        return
      }

      this.authCode = ''
      var url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.mobile +
        '&code=' +
        this.codeValue +
        '&sessionid=' +
        this.timeout +
        '&type=1&area_code=' +
        this.areaCode
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: '发送中...'
      })

      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.$toast({
            message: '发送成功',
            icon: require('../../assets/images/succ.png')
          })
          this.$toast.clear()
          this.sendstatus = true
          this.time = 60
          this.countdown()
        }
      })
    },
    chooseCountryClick: function () {
      this.$router.replace({
        path: '/country',
        query: {
          type: 'uptphone'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.uptphone {
  flex: 1;
  background: #fff;
  padding: 0.38rem 0.3rem 0;
  p {
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
  }
  b {
    display: block;
    font-size: 29px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 41px;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    .security-code {
      font-size: 0.16rem;
      height: 0.41rem;
      line-height: 0.4rem;
      margin-right: 0.15rem;
      /*border-bottom: 1px solid #5F6274;*/
      display: flex;
      display: -webkit-flex;
      display: -ms-flex;
      display: -o-flex;
      display: -moz-flex;
      align-items: center;
      -webkit-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      img {
        width: 0.16rem;
        height: 0.16rem;
        padding: 0.06rem 0.05rem 0.06rem 0.03rem;
      }
    }
  }
  .countdown {
    font-size: 0.12rem;
    color: #adadad;
    font-style: normal;
    display: block;
    margin-top: 0.19rem;
    &.sendAgain {
      color: #4a90e2;
    }
  }
  .secuCode {
    width: 100%;
    background: linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -moz-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -o-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    background: -ms-linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(246, 58, 102, 1) 100%);
    border-radius: 0.25rem;
    display: block;
    opacity: 0.39;
    font-size: 0.17rem;
    color: rgba(254, 254, 254, 1);
    line-height: 0.43rem;
    border: none;
    outline: none;
    margin-top: 0.5rem;
    &.gainRed {
      opacity: 1;
    }
  }
  .codeWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap {
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #f7f7f7;
      font-size: 0.16rem;
      color: #000;
      input {
        background: none;
        outline: none;
        border: none;
      }
      img {
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg {
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/phone/updatePhone.vue